import { useTranslation } from 'react-i18next';
import { Center, Container, Image, Text, Title } from '@mantine/core';

import errorClasses from '../error.module.css';
import { AppConstants } from '../../../constants';

const { LOGO_DARK } = AppConstants;

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <Center h={'100vh'}>
      <Container>
        <Image
          src={LOGO_DARK}
          alt={'Webcredit.ch logo'}
          mx={'auto'}
          pb={'lg'}
          className={errorClasses.logo}
        />
        <Title className={errorClasses.title}>{'In Wartung'}</Title>
        <Text size={'lg'} ta={'center'} className={errorClasses.description}>{t('Derzeit nehmen wir einige Verbesserungen vor, bitte haben Sie Geduld')}</Text>
      </Container>
    </Center>
  )
}

export default MaintenancePage;